/** Alliance create/join hub (`/alliance`) — art under `land/alliance/alliance-create-join/`. */
const ALLIANCE_CREATE_JOIN_BASE =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/alliance/alliance-create-join'

export const ALLIANCE_JOIN_PAGE_BG_URL = `${ALLIANCE_CREATE_JOIN_BASE}/join-alliance-bg.webp`
export const ALLIANCE_CREATE_JOIN_JOIN_BTN_BG_URL = `${ALLIANCE_CREATE_JOIN_BASE}/alliance_join_btn_bg.webp`
export const ALLIANCE_CREATE_JOIN_CREATE_BTN_BG_URL = `${ALLIANCE_CREATE_JOIN_BASE}/create-alliance-btn-bg.webp`
export const ALLIANCE_CREATE_JOIN_BORDER_DISPLAY_URL = `${ALLIANCE_CREATE_JOIN_BASE}/border-display.webp`
export const ALLIANCE_CREATE_JOIN_MAN_URL = `${ALLIANCE_CREATE_JOIN_BASE}/create-man.webp`
/** Shared full panel chrome for create + join tabs (replaces separate mid/top/bottom slices). */
export const ALLIANCE_CREATE_JOIN_PANEL_BG_URL = `${ALLIANCE_CREATE_JOIN_BASE}/panel-bg.webp`
export const ALLIANCE_CREATE_JOIN_INFO_PANEL_BG_URL = `${ALLIANCE_CREATE_JOIN_BASE}/info-panel-bg.webp`
export const ALLIANCE_CREATE_JOIN_GIRL_URL = `${ALLIANCE_CREATE_JOIN_BASE}/join-girl.webp`
export const ALLIANCE_CREATE_JOIN_LEFT_WING_URL = `${ALLIANCE_CREATE_JOIN_BASE}/left-wing.webp`
export const ALLIANCE_CREATE_JOIN_RIGHT_WING_URL = `${ALLIANCE_CREATE_JOIN_BASE}/right-wing.webp`
export const ALLIANCE_CREATE_JOIN_EACH_ALLIANCE_BG_URL = `${ALLIANCE_CREATE_JOIN_BASE}/each_alliance_bg.webp`
const INVITE_MODAL_BASE = `${ALLIANCE_CREATE_JOIN_BASE}/invite-modal`

/** Mobile create/join sheet close control (invite-modal art). */
export const ALLIANCE_CREATE_JOIN_MOBILE_SHEET_CLOSE_URL = `${INVITE_MODAL_BASE}/close-btn.webp`
export const ALLIANCE_INVITE_MODAL_TOP_BG_URL = `${INVITE_MODAL_BASE}/invite-modal-top-bg.webp`
export const ALLIANCE_INVITE_MODAL_MID_BG_URL = `${INVITE_MODAL_BASE}/invite-modal-mid-bg.webp`
export const ALLIANCE_INVITE_MODAL_BOTTOM_BG_URL = `${INVITE_MODAL_BASE}/invite-modal-bottom-bg.webp`
export const ALLIANCE_INVITE_MODAL_RIGHT_WING_URL = `${INVITE_MODAL_BASE}/right-wing.webp`
export const ALLIANCE_INVITE_MODAL_LOGO_URL = `${INVITE_MODAL_BASE}/invite-logo.webp`
export const ALLIANCE_INVITE_MODAL_ICONS_URL = `${INVITE_MODAL_BASE}/invite-icons.webp`

/** Startup preload — keep in sync with `vercelBlobPreloadUrls` spread. */
export const ALLIANCE_CREATE_JOIN_PRELOAD_URLS: readonly string[] = [
  ALLIANCE_JOIN_PAGE_BG_URL,
  ALLIANCE_CREATE_JOIN_JOIN_BTN_BG_URL,
  ALLIANCE_CREATE_JOIN_CREATE_BTN_BG_URL,
  ALLIANCE_CREATE_JOIN_BORDER_DISPLAY_URL,
  ALLIANCE_CREATE_JOIN_MAN_URL,
  ALLIANCE_CREATE_JOIN_PANEL_BG_URL,
  ALLIANCE_CREATE_JOIN_INFO_PANEL_BG_URL,
  ALLIANCE_CREATE_JOIN_GIRL_URL,
  ALLIANCE_CREATE_JOIN_LEFT_WING_URL,
  ALLIANCE_CREATE_JOIN_RIGHT_WING_URL,
  ALLIANCE_CREATE_JOIN_EACH_ALLIANCE_BG_URL,
  ALLIANCE_CREATE_JOIN_MOBILE_SHEET_CLOSE_URL,
  ALLIANCE_INVITE_MODAL_TOP_BG_URL,
  ALLIANCE_INVITE_MODAL_MID_BG_URL,
  ALLIANCE_INVITE_MODAL_BOTTOM_BG_URL,
  ALLIANCE_INVITE_MODAL_RIGHT_WING_URL,
  ALLIANCE_INVITE_MODAL_LOGO_URL,
  ALLIANCE_INVITE_MODAL_ICONS_URL,
]
